<template>
  <v-row justify="center">
    <v-dialog :value="dialogWindowCustomer" persistent max-width="800px">
      <v-card>
        <v-card-title  class="headline colorblue"
          primary-title>
          <v-spacer></v-spacer>
          Информация о закупке {{ getNumber }}, лот {{ getLot }}
          <v-spacer></v-spacer>
          <v-btn icon @click.stop="CloseCustomerWindow">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-5">
            <table class="pb-5">
              <tr>
                    <td width="20%">
                        <strong>Заказчик</strong>
                    </td>

                    <td>
                        {{ getCustomerInfo_name}}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>ИНН заказчика</strong>
                    </td>
                    <td>
                        {{ getCustomerInfo_inn }}
                    </td>
                </tr>
                    <tr>
                    <td>
                        <strong>Предмет</strong>
                    </td>
                    <td>
                        {{ getCustomerInfo_title}}
                    </td>
                </tr>
            </table>
            
        </v-card-text>
          
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      loading: false,

    };
  },
  methods: {
    getDateNow() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //Январь это  0!
      var yyyy = today.getFullYear();
      if (dd < 10) dd = "0" + dd;
      if (mm < 10) mm = "0" + mm;
      return dd + "." + mm + "." + yyyy;
    },

    CloseCustomerWindow() {
      this.$store
        .dispatch("toggleWinnersCustomerWindow", false)
        .then(() => {})
        .catch(error => {
          alert(error);
        });
    }
  },
  computed: {
    getNumber() {
      return this.$store.getters.getCurrentWinnerNumber;
    },
    getLot() {
      return this.$store.getters.getCurrentWinnerLot;
    },
    getCustomerInfo_inn() {
        return this.$store.getters.getCustomerinfo_inn;
    },
    getCustomerInfo_name() {
        return this.$store.getters.getCustomerinfo_name;
    },
    getCustomerInfo_title() {
        return this.$store.getters.getCustomerinfo_title;
    },
    dialogWindowCustomer() {
      return this.$store.getters.getShowCustomerWindow;
      
    }
  },
  mounted(){
    this.setTitle(`Информация о закупке ${this.getNumber}, лот ${this.getLot}`)
  }
};
</script>

<style lang="scss">
#app {
  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: #217899;
  }
  h1 {
    font-size: 1.5rem;
  }
  .bluelink {
    color: #217899;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .v-data-table-header tr th {
    padding-top: 15px;
    padding-bottom: 15px;
  }
  .v-data-table-header tr th {
    font-size: 14px;
  }
  .v-dialog table thead tr th {
    font-size: 14px;
  }
}
</style>
